$(document).find('.js_reviews-small').each((i,el) => {
    let slides = +$(el).attr('data-count')
    let buttonNext = $(el).closest('.js_reviews__container').find('.js_reviews__btn-next')
    let buttonPrev = $(el).closest('.js_reviews__container').find('.js_reviews__btn-prev')
    let pagination = $(el).closest('.js_reviews__container').find('.js_global-slider__pagination')
    new Swiper (el, {
        autoHeight: false,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1536: {
                slidesPerView: slides,
            }
        },
        navigation: {
            nextEl: buttonNext[0],
            prevEl: buttonPrev[0],
        },
        pagination: {
            el: pagination[0],
            clickable: true,
            bulletClass: 'global-slider__pagi-item',
            bulletActiveClass: 'global-slider__pagi-item_active'
        },
        modules: [SwiperModes.Navigation, SwiperModes.Pagination],
        centerInsufficientSlides: true,
    })
})

$(document).find('.js_reviews-wide').each((i,el) => {
    let buttonNext = $(el).closest('.js_reviews__container').find('.js_reviews__btn-next')
    let buttonPrev = $(el).closest('.js_reviews__container').find('.js_reviews__btn-prev')
    let pagination = $(el).closest('.js_reviews__container').find('.js_global-slider__pagination')
    new Swiper (el, {
        autoHeight: false,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: buttonNext[0],
            prevEl: buttonPrev[0],
        },
        pagination: {
            el: pagination[0],
            clickable: true,
            bulletClass: 'global-slider__pagi-item',
            bulletActiveClass: 'global-slider__pagi-item_active'
        },
        modules: [SwiperModes.Navigation, SwiperModes.Pagination],
        centerInsufficientSlides: true,
    })
})